import React from 'react';
import { useTranslation } from 'react-i18next';

const TermsOfServicePage = () => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>{t('termsOfService.title')}</h1>
      <p><strong>{t('termsOfService.effectiveDate')}</strong></p>

      <p>{t('termsOfService.p1')}</p>

      <p>{t('termsOfService.p2')}</p>

      <h2>{t('termsOfService.descriptionOfService.title')}</h2>
      <p>{t('termsOfService.descriptionOfService.p1')}</p>

      <h2>{t('termsOfService.accessAndUse.title')}</h2>
      <p>{t('termsOfService.accessAndUse.p1')}</p>

      <h2>{t('termsOfService.userContent.title')}</h2>
      <p><strong>{t('termsOfService.userContent.p1_strong')}</strong>{t('termsOfService.userContent.p1')}</p>
      <p><strong>{t('termsOfService.userContent.p2_strong')}</strong>{t('termsOfService.userContent.p2')}</p>
      <p><strong>{t('termsOfService.userContent.p3_strong')}</strong>{t('termsOfService.userContent.p3')}</p>

      <h2>{t('termsOfService.acceptableUse.title')}</h2>
      <p>{t('termsOfService.acceptableUse.p1')}</p>
      <ul>
        <li>{t('termsOfService.acceptableUse.li1')}</li>
        <li>{t('termsOfService.acceptableUse.li2')}</li>
        <li>{t('termsOfService.acceptableUse.li3')}</li>
        <li>{t('termsOfService.acceptableUse.li4')}</li>
        <li>{t('termsOfService.acceptableUse.li5')}</li>
      </ul>

      <h2>{t('termsOfService.serviceFees.title')}</h2>
      <p>{t('termsOfService.serviceFees.p1')}</p>

      <h2>{t('termsOfService.intellectualProperty.title')}</h2>
      <p>{t('termsOfService.intellectualProperty.p1')}</p>

      <h2>{t('termsOfService.termination.title')}</h2>
      <p>{t('termsOfService.termination.p1')}</p>

      <h2>{t('termsOfService.disclaimers.title')}</h2>
      <p>{t('termsOfService.disclaimers.p1')}</p>
      <p>{t('termsOfService.disclaimers.p2')}</p>
      <p>{t('termsOfService.disclaimers.p3')}</p>

      <h2>{t('termsOfService.indemnification.title')}</h2>
      <p>{t('termsOfService.indemnification.p1')}</p>

      <h2>{t('termsOfService.governingLaw.title')}</h2>
      <p>{t('termsOfService.governingLaw.p1')}</p>

      <h2>{t('termsOfService.changesToTerms.title')}</h2>
      <p>{t('termsOfService.changesToTerms.p1')}</p>

      <h2>{t('termsOfService.contactInformation.title')}</h2>
      <p>{t('termsOfService.contactInformation.p1')}</p>
      <p>
        Kevos Technologies LLC<br />
        1209 MOUNTAIN ROAD PL NE, STE R<br />
        ALBUQUERQUE, NM 87110
      </p>
    </div>
  );
};

export default TermsOfServicePage;
